<template>
    <main>
        <crumbs :crumbs="crumbs"></crumbs>
        <div class="wrap">
            <div class="title-box">
                <div class="tit">社交媒体</div>
                <div class="desc">戴尔感谢所有媒体的支持，您可通过下面的媒体了解更多峰会信息。</div>
            </div>
            <div class="list">
                <div class="left item" :class="[item.link ? 'link' : '']" v-for="item in media" @click="toLink(item)">
                    <div class="logo" :style="{backgroundImage:'url('+util.autoImage(item.image)+')'}"></div>
                    <div class="element tit">{{item.title}}</div>
                </div>
            </div>
			<sponsor/>
            <div class="loading">
                <div class="icon"></div>
            </div>
            <div class="data-loading" v-if="show_loading"><loading></loading></div>
        </div>
    </main>
</template>

<script>
    import Crumbs from "../../../components/pc/Crumbs";
    import Loading from "../../../components/pc/Loading";
	import Sponsor from "@/components/pc/Sponsor.vue";
    export default {
        name: 'media',
        data() {
            return {
                query:"",
				media:[],
                _media:[{
                    "title":"新浪",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201106/b18c9e99570eaa2caa69a3f91db27723.jpg",
                    "link":"https://zhibo.sina.com.cn/news/71038"
                },{
                    "title":"搜狐",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201106/a0655be397d3ba36e947718005b224b7.jpg",
                    "link":"https://3g.k.sohu.com/t/l80869"
                },{
                    "title":"网易新闻",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201110/b49f881354726ca6bf2791c2ec910c8d.jpg",
                    "link":"http://live.163.com/room/231609.html"
                },{
                    "title":"中国网++",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201106/4ef361be3c68f1e86a0a0f9e9bf271e6.jpg",
                    "link":"http://wjjh5.cnlive.com/videoPGC.html?isApp=false&title=%E4%BB%A5%E7%A7%91%E6%8A%80%E4%B9%8B%E5%90%8D%EF%BC%8C%E8%87%B4%E6%95%AC%E6%94%80%E7%99%BB%E8%80%85%7C2020%E6%88%B4%E5%B0%94%E7%A7%91%E6%8A%80%E5%B3%B0%E4%BC%9A&cover=http://yweb3.cnliveimg.com/bc/604/2020/1117/1605580901087_4214.jpg@base@tag=imgScale&h=360&activityId=604_0f6d647a2ac5477f85c340b71ad9d8ea&version=1.8.5&type=0&w=640&sid=10515605&onlineCount=74&plat=i&ver=1.8.5.20.09.25.18&appId=769_jetj7bq525&contentId=582010&spId=604&pid=604_0f6d647a2ac5477f85c340b71ad9d8ea&chatRoomId=AVCR_888888888&wjjFrom=apple&channeltitle=304&F=jpg&subTitle=%E4%BB%A5%E7%A7%91%E6%8A%80%E4%B9%8B%E5%90%8D%EF%BC%8C%E8%87%B4%E6%95%AC%E6%94%80%E7%99%BB%E8%80%85%7C2020%E6%88%B4%E5%B0%94%E7%A7%91%E6%8A%80%E5%B3%B0%E4%BC%9A"
                },{
                    "title":"上海热线",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201106/e95c70043b8c321662b0665dfdcae680.jpg",
                    "link":"http://it.online.sh.cn/details/34158"
                },{
                    "title":"凤凰新闻",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201106/741513e8efdd54b5454a3d5926310dce.jpg",
                    "link":"https://zhibo.ifeng.com/video.html?liveid=137048"
                },{
                    "title":"第一视频",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201106/213098b46c9f9aa13eecdc3cfe4c3c33.jpg",
                    "link":"http://share.v1.cn/share-live?id=1443&code=051CbAll2yHFY54Z6rnl2QcL3r2CbAlN&state=v1share"
                },{
                    "title":"VIVA畅读",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201106/ee98dfbb6066a708e2991ff62f53fecc.jpg",
                    "link":"https://im.vivame.net.cn/v1/live/telecast.html?playId=3540&appId=83ee783f8111b5ec3f0d888d0e5a0381&tagId=163&type=-8393460427925114462&action=115&installversion=7.4.7&apiversion=7.4.7"
                },{
                    "title":"云犀",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201117/1ad18c8c5e891ae9610b94f1fbb9a638.jpg",
                    "link":"https://play.yunxi.tv/livestream/1547b0502dad4fa0a06ea4d25e865f73"
                },{
                    "title":"淘宝",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201117/a07f6a7794ed610d5a50820ccb45a8d7.jpg",
                    "link":"https://h5.m.taobao.com/taolive/video.html?userId=3046967744&id=287731278494&spm=a2141.live_waitou&livesource=anchor_pc_share"
                },{
                    "title":"微信",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201106/947ec953b3411a0b7ae340c4ce1201e6.jpg",
                    "link":"http://live.istv.com.cn/live/tvchat-1478586272?v=1605579947325"
                },{
                    "title":"虎牙直播",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201106/81d4e2a96d60014e7961cc5f29250ab5.jpg",
                    "link":"https://www.huya.com/16255410"
                },{
                    "title":"科技视讯",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201106/ae705cf8dc0c50f8e8ae71a568ae1ef6.jpg",
                    "link":"http://www.istv.com.cn/details/34157"
                },{
                    "title":"中搜搜悦",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201106/0f07c5216dc2f5cee63e14cbf6db6cdd.jpg",
                    "link":"http://m.zhongso.com/meetingshare/index?url=meetingshare/entry&userId=5216918&foreshowId=116302&liveId=1083444&wxappid=wxe1501244fa095735&appId=souyue&scheme=wx360a9785675a8653&code=031pLZFa1P31Zz0VSmJa1lnoLN2pLZFk&state=STATE"
                },{
                    "title":"B站直播",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201106/2ae72266f406896547a6b30ac00bcf1d.jpg",
                    "link":"https://live.bilibili.com/6317122"
                },{
                    "title":"触电新闻",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201106/c44922dd3f9fb964e16a7ddc0b22d56c.jpg",
                    "link":"https://m.itouchtv.cn/liveOb/52866?shareId=8%21YONjwA&r=1605577750956"
                },{
                    "title":"斗鱼直播",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201106/347fb8362f6016cb390ad88de15dae8a.jpg",
                    "link":"https://www.douyu.com/5278401"
                },{
                    "title":"一直播",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201106/419ebba063a9ce8b2e94de8f2db19030.jpg",
                    "link":"https://www.yizhibo.com/l/0Jd-TWiiZQml_YQD.html"
                },{
                    "title":"ZOL",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201106/9261baadb8684f7c1182995619fb3a6e.jpg",
                    "link":"http://server.zol.com.cn/756/7565245.html"
                },{
                    "title":"至顶网",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201106/167234520db79ac0e570a7cc2ad8b001.jpg",
                    "link":"http://www.zhiding.cn/special/Dell_202011"
                },{
                    "title":"D1Net",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201106/e8843e1d58576951bb454ea3c0dc4c1e.jpg",
                    "link":"http://v.d1net.com/live/watch/general?id=m3n50nnl"
                },{
                    "title":"DOIT",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201106/332bebe5094e2abb2e4cdb9d177cfc3f.jpg",
                    "link":"http://tv.doit.com.cn/live/watch/technology?id=obbxyd0o"
                },{
                    "title":"IT168",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201106/49e595a5d1c05107075040e76c1fb4c5.jpg",
                    "link":"http://live.it168.com/911.html"
                },{
                    "title":"赛迪网",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201106/f9f4181c4b72b6b2a4893a6d1fe2bacb.jpg",
                    "link":"http://special.ccidnet.com/201117-1/index.shtml"
                },{
                    "title":"e-works",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201106/a56740642a18b31cd9fce833aa7d71f4.jpg",
                    "link":"http://www.icimexpo.com/View/Conference/20201118dell/dell.htm?from=singlemessage&isappinstalled=0"
                },{
                    "title":"51CTO",
                    "image":"https://dtf.dellemc-solution.com/uploads/20201106/992cfcaae535d96fae81643590265c64.jpg",
                    "link":"http://www.51cto.com/act/dell/dtf20201118"
                }],
                adv:{},
                show_loading:false,
            }
        },
        components:{
            Crumbs,Loading,Sponsor
        },
        computed:{
            crumbs() {
				return {title:"社交媒体",min_title:"social media "}
            },
        },
        methods: {
            toLink(item){
                if(item.link){
                    this.util.toLink(item.link,'','_blank')
                }
            },
            getMediaList(){
                this.show_loading = true;
                this.http.request({
                    api:"media/getMediaList",
                    success:(res)=>{
                        this.media = res.list;
                        this.show_loading = false;
                        this.$nextTick(()=>{
                            this.util.showBottom(true);
                        })
                    }
                })
            },
        },
        mounted() {
            this.query = this.$route.query;
            this.util.showBottom(true);
            this.getMediaList();
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .wrap{padding-top: 20px;
        .title-box{padding:30px;background: #fff;width: 1140px;margin:0 auto;box-shadow:0 0 10px 2px rgba(0,0,0,.1);
            .tit{font-size: 20px;line-height: 16px;border-left: 4px solid #1D56C0;padding-left: 10px;font-weight: bold;}
            .desc{font-size: 18px;margin-top: 10px;line-height: 23px;color:#565656;padding-left: 14px;white-space: pre-line}
        }
        .list{margin: 35px auto 0;width: 1200px;padding: 0 0 20px;display: flex;flex-wrap: wrap;justify-content: center;gap: 20px;
            .item{width: 284px;margin-bottom: 20px;transition: all .3s ease;
                .logo{height:160px;background-color: #fff;background-repeat: no-repeat;background-position: center center;background-size: contain;}
                .tit{font-size: 14px;line-height: 50px;padding: 0 25px;text-align: center;}
            }
            .item.link{cursor:pointer;}
        }
        .loading{padding-bottom: 50px;display: none;
            .icon{width: 32px;height:34px;margin: 0 auto; background: url("~@/assets/image/44.png") no-repeat center center;background-size: contain;}
        }
    }
</style>

